import React from "react";

import millify from "millify";

import { MetricTile } from "@covertree/ui/content";
import { GetOverviewMetricsPeriod } from "@covertree/agent-portal-graphql";
import { useAccessPattern } from "@hooks/useAccessPattern";
import { Box, Grid } from "@mui/material";
import { useGetOverviewMetrics } from "@hooks/metrics";

interface Props {
  period: GetOverviewMetricsPeriod;
}

export const Metrics: React.FC<Props> = ({ period }) => {
  const { canSeeOverviewMetricsDetailedData } = useAccessPattern();
  const { metrics, loading } = useGetOverviewMetrics(
    period,
    canSeeOverviewMetricsDetailedData
  );

  return (
    <Box mt={3}>
      <Grid container spacing={3}>
        <Grid item xs={3}>
          <MetricTile
            label="Quotes provided"
            value={metrics?.quotesAmount}
            changeValue={metrics?.quotesAmountChange}
            isLoading={loading}
            tooltip="Delta shows the difference between number of quotes created in the current selected period and the number of quotes created in the previous period."
          />
        </Grid>
        <Grid item xs={3}>
          <MetricTile
            label="Policies sold"
            value={metrics?.policiesAmount}
            changeValue={metrics?.policiesAmountChange}
            isLoading={loading}
            tooltip="Delta shows the difference between number of policies sold in the current selected period and the number of policies sold in the previous period."
          />
        </Grid>
        {canSeeOverviewMetricsDetailedData && (
          <Grid item xs={3}>
            <MetricTile
              label="Active premium"
              value={millify(metrics?.premium ?? 0)}
              changeValue={metrics?.premiumChangePercent}
              changeValueSuffix="%"
              prefix="$"
              isLoading={loading}
              tooltip="Delta shows the difference between sum of Gross Premium of all active policies in the current selected period and the sum of Gross Premium of all active policies in the previous period."
            />
          </Grid>
        )}
        {canSeeOverviewMetricsDetailedData && (
          <Grid item xs={3}>
            <MetricTile
              label="Quote to Bind Ratio"
              value={metrics?.quoteToBindRatioPercent}
              changeValue={metrics?.quoteToBindRatioPercentChange}
              changeValueSuffix="pp"
              suffix="%"
              isLoading={loading}
              tooltip="Delta shows the difference between Quote to Bind Ratio in the current selected period and the Quote to Bind Ratio in the previous period."
            />
          </Grid>
        )}
      </Grid>
    </Box>
  );
};
